import React from 'react';
import './edit-invoice.modal.sass';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { getTeamVendorId } from '../../../../login/session.slice';
import { unwrapResult } from '@reduxjs/toolkit';
import { Modal } from '../../../../../components/modal/modal';
import { Input, InputSize } from '../../../../../components/interface/input/input';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import * as Yup from 'yup';
import { patchInvoiceData } from '../../dashboard-payment.slice';

const InvoiceSchema = Yup.object().shape({
  invoiceName: Yup.string().required('Pole wymagane!'),
  invoiceAddress: Yup.string().required('Pole wymagane!'),
  invoiceNip: Yup.string().required('Pole wymagane!'),
  invoicePostalCode: Yup.string().required('Pole wymagane!'),
  invoiceCity: Yup.string().required('Pole wymagane!'),
});

export const EditInvoiceModal = ({name, nip, street, city, postalCode, isVisible, setIsVisible}) => {
  const dispatch = useDispatch();
  const sessionData = useSelector(state => state.session);
  const vendorId = getTeamVendorId(sessionData);

  const formik = useFormik({
    initialValues: {
      invoiceName: name,
      invoiceAddress: street,
      invoiceNip: nip,
      invoicePostalCode: postalCode,
      invoiceCity: city,
    },
    validationSchema: InvoiceSchema,
    onSubmit: values => {
      dispatch(patchInvoiceData({id: vendorId, ...values}))
        .then(unwrapResult)
        .then(() => {
          toast.success('Dane do faktury zaaktualizowane!');
          setIsVisible(false);
        })
        .catch(e => {
          toast.error('Coś poszło nie tak : (');
        });
    }
  });

  return (
    <Modal isOpen={isVisible} title='Edytuj dane do faktury' setVisible={setIsVisible} width={692} height={640}>
      <form className='vv-edit-invoice-modal' onSubmit={formik.handleSubmit}>
        <div className='vv-edit-invoice-modal__margin'>
          <Input
              name='invoiceName'
              id='invoiceName'
              label='Nazwa firmy'
              textError={formik.touched.invoiceName && formik.errors.invoiceName}
              value={formik.values.invoiceName}
              onChange={formik.handleChange}
          />
        </div>
        <div className='vv-edit-invoice-modal__margin'>
          <Input
              name='invoiceAddress'
              id='invoiceAddress'
              label='Adres'
              textError={formik.touched.invoiceAddress && formik.errors.invoiceAddress}
              value={formik.values.invoiceAddress}
              onChange={formik.handleChange}
          />
        </div>
        <div className='vv-edit-invoice-modal__input-container'>
          <Input
            name='invoicePostalCode'
            id='invoicePostalCode'
            label='Kod pocztowy'
            textError={formik.touched.invoicePostalCode && formik.errors.invoicePostalCode}
            inputSize={InputSize.SMALL}
            value={formik.values.invoicePostalCode}
            onChange={formik.handleChange}
          />

          <Input
            name='invoiceCity'
            id='invoiceCity'
            label='Miasto'
            textError={formik.touched.invoiceCity && formik.errors.invoiceCity}
            inputSize={InputSize.SMALL}
            value={formik.values.invoiceCity}
            onChange={formik.handleChange}
          />
        </div>
        <Input
          name='invoiceNip'
          id='invoiceNip'
          label='NIP'
          textError={formik.touched.invoiceNip && formik.errors.invoiceNip}
          value={formik.values.invoiceNip}
          onChange={formik.handleChange}
        />
        <div className='vv-edit-invoice-modal__footer'>
          <Button type='submit' text='Wyślij' buttonType={ButtonType.BLACK} size={ButtonSize.VENDOR}/>
          <Button type='button' text='Anuluj' buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR} onClick={() => setIsVisible(false)}/>
        </div>
      </form>
    </Modal>
  );
};
